import { render, staticRenderFns } from "./table.component.vue?vue&type=template&id=6b2e04a8&scoped=true"
import script from "./table.component.vue?vue&type=script&lang=js"
export * from "./table.component.vue?vue&type=script&lang=js"
import style0 from "./table.component.vue?vue&type=style&index=0&id=6b2e04a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e04a8",
  null
  
)

export default component.exports